import { render } from "./Services.vue?vue&type=template&id=496a59e5&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=496a59e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496a59e5"]])

export default __exports__